var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#E8222E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0625 18.1187L12.5625 11.8687C12.2188 11.7438 11.8313 11.8375 11.575 12.1C11.3188 12.3625 11.2438 12.7563 11.3812 13.1L13.2055 17.6692C13.3003 17.9067 13.5302 18.0625 13.7859 18.0625H18.6C19.1187 18.0625 19.5375 18.4812 19.5375 19C19.5375 19.5187 19.1187 19.9375 18.6 19.9375H13.7859C13.5302 19.9375 13.3003 20.0933 13.2055 20.3308L11.3812 24.9C11.2438 25.2437 11.3188 25.6375 11.575 25.9C11.7563 26.0875 12 26.1875 12.25 26.1875C12.3562 26.1875 12.4625 26.1687 12.5625 26.1312L30.0625 19.8812C30.4375 19.75 30.6875 19.3937 30.6875 19C30.6875 18.6062 30.4375 18.25 30.0625 18.1187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendRed);
export default __webpack_public_path__ + "static/media/SendRed.5ce86ffbcc0e4fabe02146bb2eb4f394.svg";
export { ForwardRef as ReactComponent };